<template>
  <div>
    <div class="filter-label">
      Thermostat Zone
    </div>
    <div class="filter-options">
      <div
        v-for="(z, index) in systemFilterOptions"
        :key="index"
      >
        <div>
          <div
            v-for="(tz, index) in z.thermostatZones"
            :key="index"
            class="p-5"
          >
            <SACCheckbox
              :label="`${tz.zone} (${tz.serialNumber.slice(tz.serialNumber.length - 5)})`"
              field="thermostatZone"
              :checked="existingTZone === tz.serialNumber"
              :change="() => handleSystemFilters(
                'singleThermostatZone',
                tz.serialNumber)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SACCheckbox from '../../sac/SACCheckbox.vue';

export default {
  name: 'SingleTZoneFilter',
  components: {
    SACCheckbox,
  },
  computed: {
    ...mapState({
      systemFilterOptions: state => state.customerDetail.systemFilterOptions,
      existingTZone: state => state.customerDetail.systemFilter.singleTZone,
    }),
  },
  methods: {
    handleSystemFilters(field, value, checked) {
      this.$store.dispatch(
        'setDetailSystemFilter',
        {
          field,
          value,
          checked,
        },
      );
      this.show = false;
    },
  },
};
</script>

<style scoped>

</style>
